const DEFAULT_SUFFIX = 'Copy';

export const generateNewCopyName = (name: string) => {
	const hasDefaultSuffix = name.includes(DEFAULT_SUFFIX);

	if (hasDefaultSuffix) {
		const [originalName, numberSuffix] = name.split(DEFAULT_SUFFIX);

		const hasNumberSuffix = !Number.isNaN(numberSuffix);

		const newCopyNumber = hasNumberSuffix ? Number(numberSuffix) + 1 : 1;

		return `${originalName} ${DEFAULT_SUFFIX} ${newCopyNumber}`;
	}

	return `${name} ${DEFAULT_SUFFIX}`;
};
